<template>
    <div class="classification-list">
        <ab-list-query
            :tabs="tabs"
            style="margin-top: 4px"
            :isActive="activeName"
            @handleTabs="handleTabs"
        >
            <template #right>
                <div>
                    <el-row :gutter="20">
                        <el-col :span="4">
                            <el-input
                                size="mini"
                                placeholder="订单编号"
                                v-model.trim="formSearch.entrustNumber"
                                clearable>
                            </el-input>
                        </el-col>
                        <el-col :span="4">
                             <el-select
                                    v-model="formSearch.type"
                                    size="mini"
                                    clearable
                                    placeholder="类型"
                                    @change="searchForm">
                                <el-option label="归类" value="01"></el-option>
                                <el-option label="核价" value="02"></el-option>
                            </el-select>
                        </el-col>
                         <el-col :span="4" v-if="activeName == 'signed'">
                            <ab-select
                                url="/p/user/list"
                                placeholder="确认人"
                                inputKey="realName"
                                descKey="realName"
                                v-model="formSearch.confirmIdDesc"
                                :urlData="{isEnabled: 1 , pageSize: 10, pageNum: 1}"
                                @handleSelect="itemItemUnitName">
                            </ab-select>
                        </el-col>
                        <el-col :span="4">
                            <ab-timeSearch
                                class="searchBox"
                                startSrc="发送日期起"
                                endSrc="发送日期止"
                                v-model="formSearch.updateTimeArr1"
                                @searchEvent="changeTimeRange"
                            ></ab-timeSearch>
                        </el-col>
                        <el-col :span="4" class="text-left">
                            <el-button @click="getListData">搜索</el-button>
                            <el-button link class="btn-svg" @click="formSearch={}"><ab-svg name="qingchu"></ab-svg>清除</el-button>
                        </el-col>
                    </el-row>
                </div>
            </template>

            <template #toolbar>
                <el-button type="primary" @click="exportFile" :loading="btnShow.btnLoading">导出</el-button>
            </template>

            <template #table>
                <!-- 待签署 -->
                <ab-table
                    v-if="activeName == 'pending'"
                    class="materialTable"
                    ref="table"
                    stripe
                    showEdit
                    showOrder
                    indexLabel="序号"
                    selectionWidth="45"
                    indexWidth="70"
                    widths="100"
                    isFilter="operator"
                    :dataListLoading="btnShow.isloading"
                    :column-list="columns1"
                    :table-list="tableData1"
                    @filterColumns="(param)=>filterColumns(param, 'pending')"
                >
                    <template #materiel="scope">
                        <span class="font-primary" link @click="showDrawer(scope.row)">{{ scope.row.materiel}}</span>
                    </template>
                    <template #operator="scope">
                        <el-button type="primary" link @click="confirmDialog(scope.row)">确认</el-button>                    
                    </template>
                </ab-table>
                <!-- 已签署 -->
                 <ab-table
                    v-if="activeName == 'signed'"
                    class="materialTable"
                    ref="table"
                    stripe
                    showOrder
                    indexLabel="序号"
                    selectionWidth="45"
                    indexWidth="70"
                    widths="100"
                    isFilter="confirmTime"
                    :column-list="columns2"
                    :table-list="tableData2"
                    :dataListLoading="btnShow.isloading"
                    @filterColumns="(param)=>filterColumns(param, 'signed')"
                >
                        <template #materiel="scope">
                            <span class="font-primary" link @click="showDrawer(scope.row)">{{ scope.row.materiel}}</span>
                        </template>
                        <template #isVaild='scope'>
                            <span>{{ scope.row.isVaild ? '正常' : '作废' }}</span>
                        </template>
                </ab-table>
            </template>

            <template #page>
                <ab-page
                    :pageTotal="page.total" 
                    :currentPage='page.currentPage' 
                    :pageSize="page.pageSize" 
                    :pageSizes="page.pageSizes"
                    @searchForm="pageSearch"
                ></ab-page>
            </template>
        </ab-list-query>
        <!-- 弹框 -->
        <el-drawer v-model="btnShow.drawer"  custom-class='upgradeDrawer' @open="initUploadParams"  @close="dataForm = {}">
            <template #header>
                <h4>归类核价确认</h4>
            </template>
            <template #default>
                <el-form :model="dataForm" label-position="top">
                    <el-form-item label="型号" prop="model">
                        <el-input v-model="dataForm.model" disabled/>
                    </el-form-item>
                    <el-form-item label="品牌" prop="brand">
                        <el-input v-model="dataForm.brand" disabled/>
                    </el-form-item>
                    <el-form-item label="报关品名" prop="declareGoodsName">
                        <el-input v-model="dataForm.declareGoodsName" disabled/>
                    </el-form-item>
                    <el-form-item label="单价" prop="unitPrice">
                        <el-input v-model="dataForm.unitPrice" disabled/>
                    </el-form-item>
                    <el-form-item label="结论" prop="conclusion">
                        <el-input v-model="dataForm.conclusion" autosize type="textarea" resize="none" disabled/>
                    </el-form-item>
                    <el-form-item label="备注" prop="remarks">
                        <el-input v-model="dataForm.remarks" autosize type="textarea" resize="none" class="remarks" :disabled="activeName == 'signed'"/>
                    </el-form-item>
                     <el-form-item>
                        <ab-upload :params="uploadParams" @update-billsId="updateBillsId" ref="fileUpload" v-if="dataForm.isUploadFile"></ab-upload>
                    </el-form-item>
                </el-form>
            </template>
            <template #footer v-if="activeName == 'pending'">
                <el-button type="primary" :loading="confirm" @click="confirmRemark(dataForm)">确认</el-button>
                <el-button @click="btnShow.drawer = false">取消</el-button>
            </template>
        </el-drawer>

    </div>
</template>

<script>
import { datePickTypes } from 'element-plus'
export default {
    name: 'classification-confirm-list',
    data() {
        return {
            activeName: 'pending',
            btnShow: {
                btnLoading: false,
                isloading: false,
                drawer: false,
                remarks: false
            },
            tabs: [
                { name: "待确认", value: '', state: "pending" },
                { name: "已确认", value: '', state: "signed" },
            ],
            routeQuery: {},//路由参数
            formSearch: {},//搜索参数
            columns1: [
                {
                    props: 'customerNumber',
                    labels: '订单编号',
                    widths: 90,
                },
                {
                    props: 'createTime',
                    labels: '发送时间',
                    widths: 90,
                },
                {
                    props: 'typeDesc',
                    labels: '类型',
                    widths: 60,
                },
                {
                    props: 'materiel',
                    labels: '物料',
                    widths: 150,
                    slot: 'slot',
                },
                {
                    props: 'unitPrice',
                    labels: '单价',
                    widths: 80,
                },
                {
                    props: 'conclusion',
                    labels: '结论',
                    widths: 150,
                },
            ],
            tableData1: [],
            columns2: [
                {
                    props: 'customerNumber',
                    labels: '订单编号',
                    widths: 150,
                },
                {
                    props: 'isVaild',
                    labels: '单据状态',
                    widths: 80,
                    slot: 'slot',
                },
                {
                    props: 'materiel',
                    labels: '物料',
                    widths: 200,
                    slot: 'slot',
                },
                {
                    props: 'unitPrice',
                    labels: '单价',
                    widths: 100,
                },
                {
                    props: 'conclusion',
                    labels: '结论',
                    widths: 200,
                },
                {
                    props: 'createTime',
                    labels: '发送时间',
                    widths: 150,
                },
                {
                    props: 'confirmIdDesc',
                    labels: '确认人',
                    widths: 100,
                },
                {
                    props: 'confirmTime',
                    labels: '确认时间',
                    widths: 150,
                },
            ],
            tableData2: [],
            page: {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
            //弹框数据
            dataForm: {},
             // 临时上传ID
            tempBillId: null,
            // 附件参数
            uploadParams: {
                sourceBillId: '',
                sourceBillNumber: '',
                sourceBillType: 'confirmList',
                items: [],
            },
        }
    },
    methods:{
        handleTabs(val){
            this.formSearch = {}
            this.page = {
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 20, 50, 100],
                total: 0
            },
            this.activeName = val
            this.getListData()
        },
       //日期
        changeTimeRange(obj){
            if (obj) {
                this.formSearch.createBeginDate = obj[0];
                this.formSearch.createEndDate = obj[1];
            } else {
                this.formSearch.createBeginDate = "";
                this.formSearch.createEndDate = "";
            }
        },
        //列表字段
        filterColumns(val, star){
            if(star == 'pending'){
                this.columns1 = val
            }else if(star == 'signed'){
                this.columns2 = val
            }
        },
        //翻页
        pageSearch(val){
            this.page.pageSize=val.pageSize
            this.page.currentPage=val.currentPage
            this.getListData()
        },
        //导出
        exportFile(){
            this.btnShow.btnLoading = true
            let data ={}
            let promas = {}
            if(this.activeName == 'pending'){
                promas = Object.assign({}, this.formSearch, {
                    status: 0,
                    isBusiness: false,
                })
                data.excelField = this.columns1.map((item) => item.props)
            }else if( this.activeName == 'signed'){
                promas = Object.assign({}, this.formSearch, {
                    status: 1,
                    isBusiness: false,
                })
                data.excelField = this.columns2.map((item) => item.props)
            }
            data.data = promas
            data.pageNum = 1
            data.pageSize = this.page.pageSize
            this.$post('/cms/confirmList/expList', data).then(({ data }) => {
                if (data.code === 'C0000') {
                    this.loadDown(data.result)
                    this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                }
            }).finally(() => {
                this.btnShow.btnLoading = false
            })
        },
        //下载导出
        loadDown(val){
            // 创建隐藏的可下载链接
            var eleLink = document.createElement("a");
            eleLink.download = "";
            eleLink.target = "_blank";
            eleLink.style.display = "none";
            // 字符内容转变成blob地址
            eleLink.href = val;
            // 触发点击
            document.body.appendChild(eleLink);
            eleLink.click();
            // 然后移除
            document.body.removeChild(eleLink);
        },
        //联系人
        itemItemUnitName(val){
            this.formSearch.confirmId = val.id
        },
        //获取数据pending signed
        getListData(val){ 
            this.btnShow.isloading = true
            let data ={}
            let promas = {}
            if(this.activeName == 'pending'){
                promas = Object.assign({}, this.formSearch, {
                    status: 0,
                    isBusiness: false,
                })
            }else if( this.activeName == 'signed'){
                promas = Object.assign({}, this.formSearch, {
                    status: 1,
                    isBusiness: false,
                })
            }
            data.data = promas
            data.pageNum = this.page.currentPage
            data.pageSize = this.page.pageSize
            this.$post('/cms/confirmList/list', { ...data }).then(({data})=>{
                if(data.code == 'C0000'){
                   if(this.activeName == 'pending'){
                        this.tableData1 = data.result.list
                   }else if( this.activeName == 'signed'){
                        this.tableData2 = data.result.list
                   }
                   this.page.total = data.result.total
                }
            }).finally(() => {
                this.btnShow.isloading = false
            });
        },
        //归类确定
        confirmDialog(row){
             this.$post('/cms/confirmList/confirm', row).then(({ data }) => {
                if (data.code === 'C0000') {
                    this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                }
            }).finally(() => {
                this.getListData()
            })
        },
        //弹框显示
        showDrawer(row){
            this.dataForm = {}
            this.btnShow.drawer = true
            this.dataForm = row
        },
        //弹框确认
        confirmRemark(){
            this.btnShow.remarks =true
            let data = Object.assign({}, this.dataForm, {
                remarks: this.dataForm.remarks,
                tempBillId: this.tempBillId,
            })
            if(this.dataForm.isUploadFile){
                this.$refs.fileUpload.validate().then((a)=>{
                    this.$post('/cms/confirmList/confirm', data).then(({ data }) => {
                        if (data.code === 'C0000') {
                            this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                            this.dataForm = {}
                            this.btnShow.drawer = false
                        }
                    }).finally(() => {
                        this.btnShow.remarks = false
                    })
                })
            }else{
                this.$post('/cms/confirmList/confirm', data).then(({ data }) => {
                    if (data.code === 'C0000') {
                        this.$message({type: 'success', message: data.message, offset: 380, grouping: true})
                        this.dataForm = {}
                        this.btnShow.drawer = false
                    }
                }).finally(() => {
                    this.btnShow.remarks = false
                })
            }
        },
        //弹框显示回调
        initUploadParams(){
            let items = []
            if (this.dataForm.isUploadFile) {
                if (this.dataForm.typeDesc === '归类') {
                    items.push({
                        required: true,
                        title: '品牌授权书',
                        attachType: '020',
                    })
                } else {
                    items.push({
                        required: true,
                        title: '价格佐证材料',
                        attachType: '010',
                    })
                }
            }
            this.uploadParams.sourceBillId = this.dataForm.id
            this.uploadParams.items = items
        },
        //临时id
        updateBillsId(tempBillId) {
            this.tempBillId = tempBillId
        },
    },
    created(){
        this.routeQuery = Object.keys(this.$route.query).length? this.$route.query: this.routeQuery

        if (this.routeQuery.active) {
            this.activeName = this.routeQuery.active
        }

        if (this.routeQuery.entrustNumber) {
            this.formSearch.entrustNumber = this.routeQuery.entrustNumber
        }
        this.getListData()
    },
}
</script>

<style lang="scss">
    .classification-list{
        .el-drawer{
            //滚动条的宽度
            ::-webkit-scrollbar {
                width: 8px;        
            }
            //滚动条的滑块
            ::-webkit-scrollbar-thumb {
                background-color: #aaa;
                border-radius: 3px;
                &:hover {
                    background: #999;
                }
            }
            .el-drawer__header{
                padding: 20px 40px 0;
                h4 {
                    font-size: 18px;
                    font-weight: 400;
                }
            }
            .el-drawer__body{
                padding: 20px 40px;
            }
            .el-drawer__footer {
                text-align: center;
            }
            .remarks{
                .el-textarea__inner{
                    min-height: 43px !important;
                }
            }
        }
    }
</style>